import { cn } from '@yeshuman/sdk'

/** Light auth gradient: white → `#e3f2ff` (hsl 208 100% 95%) at 56%. */
const AUTH_LIGHT_GRADIENT = 'bg-[linear-gradient(180deg,#fff_56%,#e3f2ff_100%)]'

type TalentCoBgVariant = 'default' | 'auth'

/**
 * TalentCo backdrop — app shell uses light `#eff6ff` / dark `#0f172a`;
 * auth surfaces use the login gradient in light mode.
 */
export function TalentCoBg({
  className,
  variant = 'default',
}: {
  className?: string
  variant?: TalentCoBgVariant
}) {
  return (
    <div
      aria-hidden
      className={cn(
        variant === 'auth' ? AUTH_LIGHT_GRADIENT : 'bg-[#eff6ff]',
        'dark:bg-[#0f172a]',
        className,
      )}
    />
  )
}
